<template>
  <div id="faq">
    <!-- <div v-if="!getMobile"> -->
      <div v-if="!getMobile" id="navigation">
        <div style="position: relative;">
          <Navigation />
        </div>
      </div>
      <div v-if="getMobile">
        <NavigationMobile />
      </div>

      <div :class="{centerElement : !getMobile, mobile : getMobile}">
        <div>
        </div>
        <div>
          <h1 id="title" v-if="getMobile">
            {{getText.title}}
          </h1>
          <div v-if="!getMobile" style="height: 150px;">

          </div>
          <h3 id="subTitle">
            {{getText.text}}
          </h3>

          <div class="answers">
            <div class="answersHead">
              <h2>{{getText.planks.title}}</h2>
              <p>{{getText.planks.text}}</p>
            </div>
            <v-expansion-panels>
              <v-expansion-panel v-for="(item,i) in getText.planks.info" :key="i">
                <v-expansion-panel-header class="panelHeader">
                  {{item.title}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p>{{item.text}}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div class="answers">
            <div class="answersHead">
              <h2>{{getText.frames.title}}</h2>
              <p>{{getText.frames.text}}</p>
            </div>
            <v-expansion-panels>
              <v-expansion-panel v-for="(item,i) in getText.frames.info" :key="i">
                <v-expansion-panel-header class="panelHeader">
                  {{item.title}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p>{{item.text}}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div class="answers">
            <div class="answersHead">
              <h2>{{getText.configurator.title}}</h2>
              <p>{{getText.configurator.text}}</p>
            </div>
            <v-expansion-panels>
              <v-expansion-panel v-for="(item,i) in getText.configurator.info" :key="i">
                <v-expansion-panel-header class="panelHeader">
                  {{item.title}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p>{{item.text}}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div class="answers">
            <div class="answersHead">
              <h2>{{getText.shipment.title}}</h2>
              <p>{{getText.shipment.text}}</p>
            </div>
            <v-expansion-panels>
              <v-expansion-panel v-for="(item,i) in getText.shipment.info" :key="i">
                <v-expansion-panel-header class="panelHeader">
                  {{item.title}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p>{{item.text}}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div class="answers">
            <div class="answersHead">
              <h2>{{getText.other.title}}</h2>
              <p>{{getText.other.text}}</p>
            </div>
            <v-expansion-panels>
              <v-expansion-panel v-for="(item,i) in getText.other.info" :key="i">
                <v-expansion-panel-header class="panelHeader">
                  {{item.title}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p>{{item.text}}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div style="margin-bottom: 50px;">
            <h2>{{getText.additionalIdeas}}</h2>
              <a href="tel:004915154332276" style="text-decoration: none !important;">
                  <div class="text-center" >
                    <v-btn class="ma-2" color="var(--accentColor)">
                      <span style="color:var(--mainColor);">{{getText.phone}}</span>
                    </v-btn>
                  </div>
              </a>
              <a href="mailto:info@rho-17.de?subject=Hallo,%20ich%20habe%20eine%20Frage" style="text-decoration: none !important;">
                <div class="text-center">
                  <v-btn class="ma-2" color="var(--accentColor)">
                    <span style="color:var(--mainColor);">{{getText.mail}}</span>
                  </v-btn>
                </div>
              </a>
          </div>

        </div>
        <div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import NavigationMobile from '@/components/NavigationMobile.vue'

export default {
  name: 'Faq',
  components: {
    Navigation,
    NavigationMobile
  },
  data() {
    return{
    }
   },
   computed: {
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getText(){return this.$store.getters.getText.faq;},
   },
   methods: {
   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 5);
     window.scrollTo(0, 0)
   },
}
</script>

<style scoped>
  .mobile{
    margin: 0 10px;
  }
  /* #faq > * {
    position: relative;
    color: var(--mainColor);
  } */
  p{
    color: var(--mainColor);
  }
  .panelHeader{
    color: var(--mainColor);
  }
  .answers{
    margin: 50px 0;
  }
  .answersHead{
    background-color: var(--accentColorShaded);
  }
  #title{
    margin: 60px 0 30px 0;
  }
  #subTitle{
    margin: 0 0 80px 0;
  }


</style>
